import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Rest } from 'app/rest/rest_client';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Subject, from } from 'rxjs';

@Component({
  selector: 'app-extra-filters',
  templateUrl: './extra-filters.component.html',
  styleUrls: ['./extra-filters.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ExtraFiltersComponent implements OnInit {

  @Input() extraFilters: any[] = [];
  @Input() table;
  @ViewChild('op') op: OverlayPanel;  // Declaración de la referencia al OverlayPanel
  showOverlayPanel = true;
  @Output() applyFilters = new EventEmitter<any>();


  private onDestroy$: Subject<void> = new Subject<void>();

  options: any[][] = [];
  selectedValues = [];

  constructor(private router: Router, private zone: NgZone, private cdr: ChangeDetectorRef) {
   
   
  }

  ngOnInit(){
    this.showOverlayPanel = true;
    let that = this;
    this.options = this.extraFilters.map(() => []);
    this.selectedValues = this.extraFilters.map(() => null);

  }
/*
  private sub = this.router.events
  .pipe(
    filter(event => event instanceof NavigationStart),
    map(event => event as NavigationStart),  // appease typescript
    filter(event => event.url !== '/employees')
  )
  .subscribe(
    event =>   this.hideOverlayPanel()

    
  );*/


  ngOnDestroy() {
    console.log('TableExtraColumnFiltersComponent se está destruyendo.');

    this.onDestroy$.next();
    this.onDestroy$.complete();
  }


  hideOverlayPanel() {
     // this.op.hide()
  }

/*
  filterTable(): void {
    //OLD
    this.op.hide();
    this.extraFilters.forEach(extraFilter => {
       if(extraFilter.value != null && extraFilter.value != ""){
          this.table.filter(extraFilter.value, extraFilter.field,  'startsWith' )
       }
     });
  } */
 


   onFilter(event: any, index: number) {
    var that = this;
    const filter = this.extraFilters[index];
  
    if (filter && filter.service && typeof filter.service[filter.method] === 'function') {
      // Suponiendo que getPage acepta un objeto con { page, size, search }
      var requestContext = {
        sortBy: filter.sortBy,
        sortAsc: true,
        pageSize: 10,
        filters: {},
        loadPermissions: false,
      } as Rest.ListPaginationRequest;
      
      requestContext.filters[filter.filter] = [event.filter ?? ''];
      const resultPromise = filter.service[filter.method].call(filter.service, requestContext);

    from(resultPromise).subscribe((response: any) => {
      that.options[index] = response.entities; // o como venga tu resultado
    });
    }
  }

  onOpen(event){
    this.selectedValues = this.extraFilters.map(() => null);
    this.options = this.extraFilters.map(() => []);
    this.op.toggle(event);
  }

  filterValues() {
 

    this.applyFilters.emit(this.selectedValues);
  }

  removeFilters(){
    this.selectedValues = this.extraFilters.map(() => null);
    this.applyFilters.emit(this.selectedValues);

  }


}
